export default "__VITE_ASSET__CQNHFG9T__"